import axios from "axios"
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest, ResponseRequestGeneric } from "components/Types/GeneralTypes";
import configData from "config.json";
import { authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { HorariolaboralPersona, InformacionDetalleHistorialSolicitudPermisos, InformacionGeneralSolicitudes, InformacionHijos, InformacionJornadaHorario, JornadalaboralPersona, Provincias, SolicitudLicenciasPost, SolicitudPermisos, SolicitudPermisosPost, TipoCalamidadDomestica, TipoCertificado, TipoNacimiento } from "./TypesSolicitudesPermisos";

export async function ObtenerInformacionGeneralSolicitudesPermisos(handleError: (info?: any) => void) {
    const url = configData.SERVER_URL + "SolicitudPermisos/InformacionGeneral";
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var informacionPermisos: InformacionGeneralSolicitudes = {
        solicitudesPermisos: [],
        solicitudesLicencias: [],
        permisosCRN: [],
        diasPendientes: -1, anio: -1, feriados: [],
        historial: [],
        historialbyAnio: [],
        esSubrogante: false,
        acuerdoMediosElectronicos: true,
        horaEntrada: "",
        horaSalida: "",
        tiempoAlmuerzo: "",
        horaFinAlmuerzo: "",
        horaInicioAlmuerzo: "",
        esAprobador: false,
        permisosIngresados: [],
        licenciasIngresadas: [],
        solicitudesVacaciones: [],
        licenciasComisiones: [],
        tiposSolicitudLicencias: [],
        tiposSolicitudPermisos: [],
        ubicacionFisica: "",
        empHorario: [],
        historialSolicitudesCH: [],
        solicitudesIngresadasCH: [],
        horaEntradaRegimen: "",
        horaSalidaRegimen: "",
        subtipoPermisos: [],
        horarioLaboralRegimen: {
            idRegimen: 0,
            horaEntrada: "",
            horaSalida: "",
            horaInicioReceso: "",
            horaFinReceso: ""
        },
        horarioLaboralPersona: [],
        jornadaLaboralPersona: [],
        tieneHorarioPermiso: false,
        tieneInfanteRegistrado: true,
        vacacionesIngresadas: [],
        estadoCivil: "",
        identificacionConyuge: "",
        tipoEventoMatrimonio: "",
        modalidadLicenciaMatrimonio: "",
        tipoIdentificacion: "",
        Conyuge: "",
        idRegimenLaboralS: 0,
        listadoHorarios: [],
        licenciaMaternidad: [],
        fechaFinContrato: "",
    }
    var infoResponse: ResponseRequest = { status: -1, dataResponse: informacionPermisos }
    try {

        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )

        informacionPermisos = respuesta.data;
       if(informacionPermisos.solicitudesPermisos.length > 0){
            const solicitudesMapping:SolicitudPermisos[] = informacionPermisos.solicitudesPermisos.map((val,ind) =>{
                return (
                    {
                        ...val,
                        nuevas: val.idPermiso === undefined
                    }
                )
            })
            informacionPermisos = {...informacionPermisos,solicitudesPermisos:solicitudesMapping}
       } 
       
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionPermisos,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionPermisos,
                errorMessage: error.response.data ?? ""
            }
            handleError(infoResponse.errorMessage);
        }
        else {
            handleError();
        }
    }

    return infoResponse;

}

export async function ObtenerInformacionHorarioLaboral(fecha: string) {
    const url = configData.SERVER_URL + "SolicitudPermisos/ObtenerHorariobyfecha/"+fecha;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var informacionHorario: HorariolaboralPersona[]
    var infoResponse: ResponseRequest = { status: -1, dataResponse: [] }
    try {

        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )

        informacionHorario = respuesta.data;
       
       
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionHorario,
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: [],
                errorMessage: error.response.data ?? ""
            }
        }
    }

    return infoResponse;

}

export async function ObtenerInformacionJornadaLaboral(fecha: string) {
    const url = configData.SERVER_URL + "SolicitudPermisos/ObtenerJornadabyfecha/"+fecha;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var informacionJornada: JornadalaboralPersona[]
    var infoResponse: ResponseRequest = { status: -1, dataResponse: [] }
    try {

        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )

        informacionJornada = respuesta.data;
       
       
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionJornada,
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: [],
                errorMessage: error.response.data ?? ""
            }
        }
    }

    return infoResponse;

}

export async function ObtenerDetalleHistorial(anio:number){
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse:ResponseRequest = {status:-1}
    const URL_HISTORIAL_DETALLE = configData.SERVER_URL + "SolicitudPermisos/DetalleHistorial/" + anio
    try {
        const respuesta = await axios.get(URL_HISTORIAL_DETALLE,{
            headers:authHeaderWithToken(infoUsuario.token)
        })    
        const dataResponse:InformacionDetalleHistorialSolicitudPermisos = respuesta.data;
        
        respuestaResponse ={
            status:respuesta.status,
            dataResponse
        }

    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            respuestaResponse = {status:error.response.status}
        }
    } 

    return respuestaResponse;
}

export async function SolicitarPermisosFormulario(solicitud:SolicitudPermisosPost,  acuerdoMediosElectronicos:boolean){
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse:ResponseRequest = {status:-1}

    var URL_DOCUMENTO = "SolicitudPermisos/SolicitarPermisoAtencionMedica/VistaPreviaFormulario";



    const url = `${configData.SERVER_URL}${URL_DOCUMENTO} ` 
    try {
        const respuesta = await axios.post(url,solicitud,
                {
                    headers:authHeaderWithToken(infoUsuario.token),
                    responseType:"blob"
                }
            )

            const blob_resource = await respuesta.data;
            const url_documento = window.URL.createObjectURL(blob_resource);
        respuestaResponse = {status:respuesta.status,dataResponse:url_documento}
        
    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();    

            respuestaResponse = {status:error.response.status,errorMessage:mensaje}
        }
        else if (axios.isAxiosError(error) && !error.response){
            respuestaResponse = {status:-1,errorMessage:"No ha sido posible contactar con el servidor. Intente más tarde."}
        }
    }
    return respuestaResponse
}

export async function SolicitarLicenciasFormulario(solicitud: SolicitudLicenciasPost, acuerdoMediosElectronicos: boolean) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }

    var URL_DOCUMENTO = "SolicitudPermisos/SolicitarLicenciaCalamidadDomestica/VistaPreviaFormulario";

    const url = `${configData.SERVER_URL}${URL_DOCUMENTO} `
    try {
        const respuesta = await axios.post(url, solicitud,
            {
                headers: authHeaderWithToken(infoUsuario.token),
                responseType: "blob"
            }
        )

        const blob_resource = await respuesta.data;
        const url_documento = window.URL.createObjectURL(blob_resource);
        respuestaResponse = { status: respuesta.status, dataResponse: url_documento }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
        else if (axios.isAxiosError(error) && !error.response) {
            respuestaResponse = { status: -1, errorMessage: "No ha sido posible contactar con el servidor. Intente más tarde." }
        }
    }
    return respuestaResponse
}

//export async function SolicitarLicenciasMatrimonio(solicitud: SolicitudLicenciasMatrimonio, acuerdoMediosElectronicos: boolean) {
//    const infoUsuario: UserData = authenticationService.currentUserValue;
//    var respuestaResponse: ResponseRequest = { status: -1 }

//    var URL_DOCUMENTO = "SolicitudPermisos/SolicitarLicenciaCalamidadDomestica/VistaPreviaFormulario";

//    const url = `${configData.SERVER_URL}${URL_DOCUMENTO} `
//    try {
//        const respuesta = await axios.post(url, solicitud,
//            {
//                headers: authHeaderWithToken(infoUsuario.token),
//                responseType: "blob"
//            }
//        )

//        const blob_resource = await respuesta.data;
//        const url_documento = window.URL.createObjectURL(blob_resource);
//        respuestaResponse = { status: respuesta.status, dataResponse: url_documento }

//    } catch (error) {
//        if (axios.isAxiosError(error) && error.response) {
//            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

//            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
//        }
//        else if (axios.isAxiosError(error) && !error.response) {
//            respuestaResponse = { status: -1, errorMessage: "No ha sido posible contactar con el servidor. Intente más tarde." }
//        }
//    }
//    return respuestaResponse
//}

export async function SolicitarPermisosLicenciasCreacion(formData: FormData){
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "SolicitudPermisos/CrearPermisoLicencia"
    try {
        const respuesta = await axios.post(url,formData,
                {
                    headers:authHeaderWithToken(infoUsuario.token),
                }
            )
        respuestaResponse = {status:respuesta.status,dataResponse:respuesta.data}
        
    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            respuestaResponse = {status:error.response.status,errorMessage:error.response.data}

        }
    }
    return respuestaResponse
}

export async function AnularSolicitudPermisos(idSolicitud:number){
    const infoUsuario: UserData = authenticationService.currentUserValue;

    const URL = configData.SERVER_URL + `SolicitudPermisos/AnularSolicitudPermisos/${idSolicitud}`

    try {
        const respuesta = await axios.put(URL,{},{
            headers:authHeaderWithToken(infoUsuario.token)
        })

        return 1
    } catch (error) {
        return -1

    }



}

export async function SolicitarPermisosAtencionMedicaEdicion(formData: FormData){
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse:ResponseRequest = {status:-1}

    const url = configData.SERVER_URL + "SolicitudPermisos/EditarSolicitudPermisos"
    try {
        const respuesta = await axios.put(url,formData,
                {
                    headers:authHeaderWithToken(infoUsuario.token),
                }
            )
        respuestaResponse = {status:respuesta.status,dataResponse:respuesta.data}
        
    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            respuestaResponse = {status:error.response.status,errorMessage:error.response.data}

        }
    }
    return respuestaResponse
}

export async function ObtenerTiposCalamidad() {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL_TIPOS_CALAMIDAD = configData.SERVER_URL + "SolicitudPermisos/ObtenerTipoCalamidadDomestica";
    try {
        const respuesta = await axios.get(URL_TIPOS_CALAMIDAD, {
            headers: authHeaderWithToken(infoUsuario.token)
        })
        const dataResponse: TipoCalamidadDomestica[] = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status }
        }
    }

    return respuestaResponse;
}

export async function ObtenerProvincias() {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL_TIPOS_CALAMIDAD = configData.SERVER_URL + "SolicitudPermisos/ObtenerProvincias";
    try {
        const respuesta = await axios.get(URL_TIPOS_CALAMIDAD, {
            headers: authHeaderWithToken(infoUsuario.token)
        })
        const dataResponse: Provincias[] = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status }
        }
    }

    return respuestaResponse;
}

export async function ObtenerTiposMaternidad() {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL_TIPOS_MATERNIDAD = configData.SERVER_URL + "SolicitudPermisos/ObtenerTipoMaternidad";
    try {
        const respuesta = await axios.get(URL_TIPOS_MATERNIDAD, {
            headers: authHeaderWithToken(infoUsuario.token)
        })
        const dataResponse: TipoNacimiento[] = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status }
        }
    }

    return respuestaResponse;
}

export async function ObtenerTiposPaternidad() {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL_TIPOS_PATERNIDAD = configData.SERVER_URL + "SolicitudPermisos/ObtenerTipoPaternidad";
    try {
        const respuesta = await axios.get(URL_TIPOS_PATERNIDAD, {
            headers: authHeaderWithToken(infoUsuario.token)
        })
        const dataResponse: TipoNacimiento[] = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status }
        }
    }

    return respuestaResponse;
}

export async function ObtenerTiposCertificado() {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL_TIPOS_CERTIFICADO = configData.SERVER_URL + "SolicitudPermisos/ObtenerTipoCertificado";
    try {
        const respuesta = await axios.get(URL_TIPOS_CERTIFICADO, {
            headers: authHeaderWithToken(infoUsuario.token)
        })
        const dataResponse: TipoCertificado[] = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status }
        }
    }

    return respuestaResponse;
}

export async function ObtenerHijosPersona() {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL_INFO_HIJOS = configData.SERVER_URL + "SolicitudPermisos/ObtenerInformacionHijos";
    try {
        const respuesta = await axios.get(URL_INFO_HIJOS, {
            headers: authHeaderWithToken(infoUsuario.token)
        })
        const dataResponse: InformacionHijos[] = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status }
        }
    }

    return respuestaResponse;
}
